import React, { useEffect, useState, useRef, useContext } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import SVG from 'react-inlinesvg'
import { Link } from 'gatsby'

import { listLocalizedPaths } from '../../utils/helpers/localization/localize'
import { LoadingContext } from '../../utils/contexts/loader-context'
import useOnClickOutside from '../../utils/hooks/useOnClickOutside'
import chevron from '../../assets/icons/chevron.svg'
import world from '../../assets/icons/world.svg'

/**
 * Display the page language selector
 */
const LocaleSwitch = ({ className, pageContext, languageIcon, selectorIcon, layout, title }) => {
  const select = useRef()
  const { loading } = useContext(LoadingContext)
  const [isLoading, setLoading] = loading
  const [locale, setLocale] = useState(pageContext.locale)
  const [showing, setShowing] = useState(false)
  const [localizedPaths, setLocalizedPaths] = useState(null)
  const [dropDownHeight, setDropDownHeight] = useState(0)
  const localeSlugs = pageContext.localizations.data ? pageContext.localizations.data : (pageContext.localizations ? pageContext.localizations : [])
  let pageDirectories = pageContext.pageDirectories ? pageContext.pageDirectories : []

  const handleLocaleChange = async selectedLocale => {
    setLoading(true)
    setLocale(selectedLocale)
  }
  useOnClickOutside(select, () => setShowing(false))

  // Update the language selector links when locale or page context changes
  useEffect(() => {
    const postType = pageContext.postType
    const changeLocale = async () => {
      setShowing(false)
      const slugs = await listLocalizedPaths(pageContext, postType, pageDirectories, localeSlugs)
      setLocalizedPaths(slugs)
      const heigth = 'auto' // Set the dropdown height to 45px * the number of locales
      setDropDownHeight(heigth)
    }
    changeLocale()
  }, [locale, pageContext])

  return (
    <div
      ref={select}
      className={`nav-locale ${layout === 'base' ? 'nav-locale-base' : 'nav-locale-full'} w-full flex flex-col h-full`}
    >
      <button
        className={`inline-flex items-center justify-between w-full relative h-full px-0`}
        aria-expanded={showing ? true : false}
        onClick={() => setShowing(!showing)}
      >
        <div className={`inline-flex items-center justify-between lg:justify-center fill-current w-full uppercase ${className ? className : ''}`}>
          {layout !== 'text' && (
            languageIcon && languageIcon !== null ? (
              <SVG
                onError={error => console.log(error.message)}
                cacheRequests={true}
                preProcessor={code =>
                  code.replace(/fill=".*?"/g, 'fill="currentColor"')
                }
                src={languageIcon}
                className={`nav-icon-language w-7 h-7 xxxl:h-9 xxxl:w-9 ${layout === 'base' ? 'block' : (layout === 'hybrid' ? 'block lg:hidden' : 'hidden lg:block')}`}
              />
            ) : (
              <SVG
                onError={error => console.log(error.message)}
                cacheRequests={true}
                preProcessor={code =>
                  code.replace(/fill=".*?"/g, 'fill="currentColor"')
                }
                src={world}
                className={`nav-icon-language w-7 h-7 xxxl:h-9 xxxl:w-9 ${layout === 'base' ? 'block' : (layout === 'hybrid' ? 'block lg:hidden' : 'hidden lg:block')}`}
              />
            )
          )}
          <span className={`font-bold ${layout === 'base' ? 'hidden' : (layout === 'text' ? 'inline-block' : (layout === 'hybrid' ? 'hidden lg:inline-block' : 'inline-block lg:hidden'))}`}>
            {title ? title : 'Language'}
          </span>
          {selectorIcon && selectorIcon !== null ? (
            <SVG
              onError={error => console.log(error.message)}
              cacheRequests={true}
              preProcessor={code =>
                code.replace(/fill=".*?"/g, 'fill="currentColor"')
              }
              src={selectorIcon}
              className="nav-icon-selector subnav-indicator ml-4 h-6 w-6 transform"
            />
          ) : (
            <SVG
              onError={error => console.log(error.message)}
              cacheRequests={true}
              preProcessor={code =>
                code.replace(/fill=".*?"/g, 'fill="currentColor"')
              }
              src={chevron}
              className="subnav-indicator ml-4 h-6 w-6 transform"
            />
          )}
        </div>
      </button>
      <AnimatePresence>
        {showing && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: dropDownHeight }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3 }}
            className={`nav-locale-selector z-10 min-w-[100px] w-auto overflow-hidden top-full right-0 ${layout && layout === 'base' ? 'absolute' : 'lg:absolute'}`}>
            {localizedPaths?.map(({ href, name, enName, locale, published }) => {
              if (process.env.GATSBY_ENV !== 'prod' || published !== false || process.env.GATSBY_DATA_SOURCE === 'local') {
                return (
                  <Link
                    to={href}
                    key={locale}
                    onClick={() => handleLocaleChange(locale)}
                    role="option"
                    title={`${name} ${enName ? `(${enName})` : ''}`}
                    className="locale-selector h-auto text-left z-10 block cursor-pointer py-4 px-24 lg:px-12 transition-all duration-300"
                  >
                    {name}
                  </Link>
                )
              }
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div >
  )
}

export default LocaleSwitch
